export function syncAppBadge(_count?: number) {}
export function clearOpenedNotification() {}
